import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';

@Injectable()

export class BankerDshboardService {

  constructor(private http: Http, private router: Router) { }

  public Liquidations() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/banker/liquadation_due',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  public interest() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/banker/interest',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  public topCustomers() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/banker/top_customers',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }


  public counter_parties_with_payment_outstanding() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/analytics/banker/counter_parties_with_payment_outstanding',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }


  //  Score card
  public scoreCard(userid) {
    console.log('inside services');
    // return this.http.get(environment.panUrl+'/verification/getscorecard/'+userid,
    // GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
    return this.http.get(environment.baseUrl + '/cam/get_score/' + userid,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        //   return this.http.get('http://localhost:4200/proxy'+'/verification/getscorecard/'+userid,
        // GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user); 
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // 
  //  Score card
  public Cam(userid) {
    console.log('inside services');
    // /verification/getcam/
    return this.http.get(environment.baseUrl + '/cam/get_cam/' + userid,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user); 
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // get user by user id

  //  Score card
  public userDetails(userid) {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/user/getdetails/' + userid,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user); 
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // create u w
  public onCreateuw(formdata) {

    const data = {
      "emailId": formdata.emailId,
      "name": formdata.name,
      "password": "test@123",
      "phone": formdata.phone,
      "roles": ["underwriter"]
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/underwriter/uw_register', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // get underwriter list
  public underwriterList() {
    const lenderId = localStorage.getItem('bankerId')
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/user/list_of_underwriters/' + lenderId,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  //  update under writer
  public onUpdateuw(formdata) {

    const data = {
      "emailId": formdata.emailId,
      "name": formdata.name,
      "password": "uw@123",
      "phone": formdata.phone,
      "roles": ["underwriter"]
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/underwriter/uw_register', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public getUserProfile() {
    console.log('inside services');
    const bankerId = localStorage.getItem('bankerEmail');
    const userId = bankerId
    return this.http.get(environment.baseUrl + '/user/getdetails/' + userId, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log("[BankerDshboardService getUserProfile] userprofile", user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500 || error.status === 400 || error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  // update user profile

  // public updateCamKYC()

  public updateCamKYC(CustCamData, companyDetails, aplicantDetails, product, loanRequestAmount) {

    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    const data = {
      "emailId": CustCamData,
      "DetailAboutCompany": companyDetails,
      "noOfOffices": aplicantDetails.no_of_offices,
      "noOfWarehouse": aplicantDetails.no_of_warehouse,
      "noOfEMPShowroom": aplicantDetails.no_of_emp_showroom,
      "noOfEMPWarehouse": aplicantDetails.no_of_emp_warehouse,
      "typeOfOffices": aplicantDetails.owned_rented,
      "residentialSpace": aplicantDetails.residentialSpace,
      "productCategory": product,
      "loanRequestAmount": loanRequestAmount
    };

    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/user/update_kyc', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        headerToken;
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });

  }

  // cam update code start here  

  public updateCAM(CustCamData, transactionData, transactionDataTotal, processingFees, rateOfInterest, groupExposure, groupExposurTotal, companyDetails, stockData, stockWithDealershipTotal, debtors, debitorWithDealershipTotal, workingCapital, workingCapitalTotal, eligibilityComputation, dedupe, deviationAndApproval,
    aplicantDetails, directorPartner, otherCharges, security, comments, recommendArray, loanRequestAmount, product, otherDetailsValue) {
    console.log(aplicantDetails, "Email_______Id")
    const userid = CustCamData;

    const data = {
      "userid": userid,
      "companyPromoterDetails": companyDetails,
      "noOfOffices": aplicantDetails.no_of_offices,
      "noOfWarehouse": aplicantDetails.no_of_warehouse,
      "noOfEMPShowroom": aplicantDetails.no_of_emp_showroom,
      "noOfEMPWarehouse": aplicantDetails.no_of_emp_warehouse,
      "typeOfOffices": aplicantDetails.owned_rented,
      "residentialSpace": aplicantDetails.residentialSpace,
      "productCategory": product,
      "loanRequestAmount": loanRequestAmount,
      "comments": {
        "generalCondition": comments.generalCondition,
        "specialCondition": comments.specialCondition,
        "recommendedBy": recommendArray,
        //[
        // { 
        //     "personOneKey": recomendedBy.name,
        //     "personOneValue": recomendedBy.companyName,
        //     "personTwoKey": recomendedBy.name1,
        //     "personTwoValue": recomendedBy.companyName1,
        //     "personThreeKey": recomendedBy.name2,
        //     "personThreeValue": recomendedBy.companyName2,
        //     "personFourKey": "",
        //     "personFourValue": "",
        //     "personFiveKey": "",
        //     "personFiveValue": ""
        // }
        //   {
        //     "name": recommendArray[0].name,
        //     "emp_id": recomendedBy.companyName,
        //     "org": recomendedBy.orgName,
        //     "comment": recomendedBy.comment
        // },
        // {
        //     "name": recomendedBy.name1,
        //     "emp_id": recomendedBy.companyName1,
        //     "org": recomendedBy.orgName1,
        //     "comment": recomendedBy.comment1
        // },
        // {
        //     "name": recomendedBy.name2,
        //     "emp_id": recomendedBy.companyName2,
        //     "org": recomendedBy.orgName2,
        //     "comment": recomendedBy.comment2
        // }

        //],
      },
      "camDetails": {
        "customerDetails": {
          "customerRelationshipNo": "-",
          "product": product,
          "dealerName": "-",
          "location": "-",
          "date": "-",
          "manufacturer": "-",

          "region": "-",
          "loanRequestAmount": loanRequestAmount
        },
        "otherInfo": [
          {
            "otherInfoOneKey": otherDetailsValue.otherKeyName1,
            "otherInfoOneValue": otherDetailsValue.otherKeyValue1,
            "otherInfoTwoKey": otherDetailsValue.otherKeyName2,
            "otherInfoTwoValue": otherDetailsValue.otherKeyValue2,
            "otherInfoThreeKey": otherDetailsValue.otherKeyName3,
            "otherInfoThreeValue": otherDetailsValue.otherKeyValue3,
            "otherInfoFourKey": otherDetailsValue.otherKeyName4,
            "otherInfoFourValue": otherDetailsValue.otherKeyValue4,
            "otherInfoFiveKey": otherDetailsValue.otherKeyName5,
            "otherInfoFiveValue": otherDetailsValue.otherKeyValue5,
          }
        ],
        "transactionDetails": [
          {
            "data": transactionData,
            "total": transactionDataTotal,
            "rateOfInterest": rateOfInterest,
            "processingFees": processingFees,
            "otherCharges": otherCharges
          }
        ],
        "security": security,
        "groupExposure": [
          {
            "data": groupExposure,
            "total": groupExposurTotal
          }
        ],
        "applicantDetails": {
          "registeredAddress": aplicantDetails.registered_address,
          "corrospondenceAddress": aplicantDetails.corrospondence_address,
          "telephoneNumber": aplicantDetails.telephone_number,
          "emailId": aplicantDetails.emailId,
          "dateOfIncorporation": aplicantDetails.date_of_incorporation,
          "dateOfCommencementOfBusiness": aplicantDetails.date_of_commencement_of_business,
          "pan": aplicantDetails.pan,
          "noOfOffices": aplicantDetails.no_of_offices,
          "noOfWarehouse": aplicantDetails.no_of_warehouse,
          "noOfEmpShowroom": aplicantDetails.no_of_emp_showroom,
          "noOfEmpWarehouse": aplicantDetails.no_of_emp_warehouse,
          "ownedRented": aplicantDetails.owned_rented

        },
        "directorPartnerDetails": [
          {
            "data": directorPartner
          }
        ],

        "companyPromoterDetails": companyDetails,
        "stocks": [
          {
            "data": stockData,
            "total": stockWithDealershipTotal
          }
        ],
        "debtors": [
          {
            "data": debtors,
            "total": debitorWithDealershipTotal
          }
        ],
        "workingCapital": [
          {
            "data": workingCapital,
            "total": workingCapitalTotal
          }
        ],
        "eligibilityComputation": [
          {
            "data": eligibilityComputation
          }
        ],
        "dedupe": [
          {
            "data": dedupe
          }
        ],
        "deviationAndApproval": [
          {
            "data": deviationAndApproval
          }
        ]
      }
    };
    // console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    // verification/updatecam/
    return this.http.put(environment.baseUrl + '/cam/update_cam', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // create approve id for sales user
  public approveId(approveid) {

    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    const data = {
      "customerId": approveid,
      "status": "submitted",
      "adminRemarks": "Cam is proper"

    };

    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/admin/submit_to_lender', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        headerToken;
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });

  }

  // reject 
  public userReject(approveid, rejection) {

    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    const data = {
      "customerId": approveid,
      "status": "rejected",
      "adminRemarks": rejection.remarks

    };

    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/admin/submit_to_lender', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        headerToken;
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });

  }
  // send back
  public userSendBack(approveid, rejection) {

    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    const data = {
      "customerId": approveid,
      "status": "send back",
      "adminRemarks": rejection.remarks

    };

    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/admin/submit_to_lender', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        headerToken;
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });

  }

  //// update password 
  public updatePassword(formdata) {
    const emailId = localStorage.getItem('channelEmail')
    const data = {
      "emailId": emailId,
      "oldPassword": formdata.currentPassword,
      "newPassword": formdata.newPassword
    }
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/reset__password', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

}
